// extracted by mini-css-extract-plugin
export default {"progress":"StudentProgressCategory_progress__jrDKR","list":"StudentProgressCategory_list__fS6ul"};